import { render } from "./AddAuthItemComponent.vue?vue&type=template&id=0a7b353a&scoped=true"
import script from "./AddAuthItemComponent.vue?vue&type=script&lang=js"
export * from "./AddAuthItemComponent.vue?vue&type=script&lang=js"

import "./AddAuthItemComponent.vue?vue&type=style&index=0&id=0a7b353a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7b353a"]])

export default __exports__